import {useState} from "react";
import {Stack, TextField, Typography} from "@mui/material";
import {z} from "zod";
import {zodSubmit} from "../../../utils/FormUtils";

const schema = z.object({
    email: z.string().email({ message: 'Érvénytelen email cím!' }),
});

const NewColleague = ({handleSubmit, reference}) => {
    const [errors, setErrors] = useState({});

    return <form
        ref={reference}
        onSubmit={e => zodSubmit(e, setErrors, handleSubmit, schema)}
    >
        <Stack spacing={2}>
            <Typography variant='caption' color='primary.main'>Meghívandó kolléga e-mail címe*</Typography>
            <TextField
                error={!!errors.email}
                helperText={errors.email}
                name='email'
                variant='standard'
            />
        </Stack>

    </form>
}

export default NewColleague